<template>
    <button
        class="circle-button u-flex u-flex--center u-reset-button"
        :class="`circle-button--${theme} circle-button--size-${size}`"
        :title="title"
    >
        <spinner v-if="isLoading" />
        <app-icon v-else :name="icon" hidden class="circle-button__icon d-block m-0 p-0" />
    </button>
</template>

<script>
import AppIcon from '@/components/ui/Icon.vue'
import Spinner from '@/components/ui/Spinner.vue'

const buttonThemes = ['default', 'primary', 'highlight']

export default {
    name: 'CircleButton',

    components: { Spinner, AppIcon },

    props: {
        icon: { type: String, required: true },
        title: { type: String, required: true },
        theme: { type: String, default: 'default', validator: val => buttonThemes.includes(val) },
        size: { type: String, default: 'default', validator: val => ['default', 'small', 'medium'].includes(val) },
        isLoading: { type: Boolean, default: false },
    },
}
</script>

<style lang="scss" scoped>
$circle-button-size-default: 40px;
$circle-button-size-small: 30px;
$circle-button-size-medium: 70px;

.circle-button {
    border-radius: $border-radius-round;
    height: $circle-button-size-default;
    width: $circle-button-size-default;
    background: $tertiary-color;
    color: $secondary-color;
    border: 1px solid darken($tertiary-color, 10%);

    @include interaction {
        background: darken($tertiary-color, 10%);
    }

    &--primary {
        background: $primary-color;
        color: $white;
        border: 1px solid $primary-color;

        @include interaction {
            background: lighten($primary-color, 6%);
            border-color: lighten($primary-color, 6%);
        }
    }

    &--highlight {
        background: $highlight-color;
        color: $white;
        border: 1px solid $highlight-color;

        @include interaction {
            background: lighten($highlight-color, 6%);
            border-color: lighten($highlight-color, 6%);
        }
    }

    &__icon {
        overflow: inherit;
    }

    &--size-small {
        height: $circle-button-size-small;
        width: $circle-button-size-small;
    }

    &--size-medium {
        height: $circle-button-size-medium;
        width: $circle-button-size-medium;

        .circle-button__icon {
            height: 1.6rem;
            width:  1.6rem;
        }
    }
}
</style>
